import React, { useState, useEffect } from 'react';

const AllList = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await fetch('https://admindashboard.clns.in/api/dash/alllist/');
        if (!response.ok) {
          throw new Error('Failed to fetch users');
        }
        const data = await response.json();
        setUsers(data.results); // Assuming the structure of your response has 'results' field
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div className="p-4">
      <table className="w-full border-collapse bg-white shadow-lg rounded-lg overflow-hidden">
        <thead>
          <tr className="bg-gray-100">
            <th className="border border-gray-200 p-3 text-left font-semibold">Name</th>
            <th className="border border-gray-200 p-3 text-left font-semibold">Location</th>
            <th className="border border-gray-200 p-3 text-left font-semibold">Phone no.</th>
            <th className="border border-gray-200 p-3 text-left font-semibold">Email</th>
            <th className="border border-gray-200 p-3 text-left font-semibold">User Type</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user, index) => (
            <tr 
              key={index}
              className="hover:bg-gray-50 transition-colors duration-200"
            >
              <td className="border border-gray-200 p-3">{user.name}</td>
              <td className="border border-gray-200 p-3">{user.address || user.location}</td>
              <td className="border border-gray-200 p-3">{user.mobile_num}</td>
              <td className="border border-gray-200 p-3">{user.email}</td>
              <td className="border border-gray-200 p-3">{user.user_type}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AllList;
